module.exports = __webpack_public_path__ + "img/service-effect-1.12d63675.png";